import { Panel, PanelPosition } from "@swivl-mono/ui";
import React from "react";

import { TaskList } from "./TaskList";
import { TicketDetailPanel } from "./TicketDetailPanel";

interface TicketFlyoutProps {
  isOpen: boolean;
  onClose: () => void;
  /** Open the full ticket detail page (navigates to /inbox/ticket/:number). */
  onExpand: () => void;
}

// The ticket fields (Select, date picker, customer modal) render their popovers
// in portals appended to <body>, which register as clicks "outside" the panel.
// Ignore those so editing a field doesn't close the flyout.
function shouldIgnoreOutsideClick(event: MouseEvent): boolean {
  const target = event.target as HTMLElement | null;
  return !!target?.closest?.('[data-radix-popper-content-wrapper],[data-floating-ui-portal],[role="menu"],[role="listbox"],[role="dialog"]');
}

/** Right slide-over showing the selected ticket (reuses the full detail panel). */
export function TicketFlyout({ isOpen, onClose, onExpand }: TicketFlyoutProps): React.JSX.Element {
  return (
    <Panel
      isOpen={isOpen}
      onToggle={onClose}
      position={PanelPosition.RIGHT}
      // Wide enough for the header to sit on one line: ticket number, View
      // Conversation, status pill, and Go to Ticket all compete for this row.
      width="600px"
      title="Ticket"
      // Match the escalation edit flyout: quicker, smoother slide than the default.
      transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
      shouldIgnoreOutsideClick={shouldIgnoreOutsideClick}
    >
      <div className="h-full bg-white">
        <TicketDetailPanel onExpand={onExpand} tasksSlot={<TaskList embedded />} />
      </div>
    </Panel>
  );
}
